import { render, staticRenderFns } from "./CrossClient.vue?vue&type=template&id=22bcb970&lang=true"
import script from "./CrossClient.vue?vue&type=script&lang=js"
export * from "./CrossClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports